import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { businessNetworkMembers, TEXT_FIELDS } from '../../customer-service.service';
import Swal from 'sweetalert2';
import { SWAL_WITH_BUTTONS } from 'src/app/services/FormValidation';
import { UtilService } from 'src/app/services/util.service';
import { ManageTemplateComponent } from '../../manage-template/manage-template.component';

@Component({
  selector: 'app-network-details',
  standalone: true,
  imports: [CommonModule, ManageTemplateComponent],
  templateUrl: './network-details.component.html',
  styleUrls: ['./network-details.component.scss']
})
export class NetworkDetailsComponent implements OnInit {

  fields : Array<Partial<TEXT_FIELDS>>;
  columns : Array<Partial<TEXT_FIELDS>>;
  businessNetworkDetails !: any;
  userDatas = new BehaviorSubject([]);
  businessNetworkId: any;
  prevSearchAfterKey : any;
  stopScroll : boolean = false;
  payload = {
    limit: 10,
    page: 1,
    searchContent : null,
    status : null,
    searchAfterKey : null
  }
  constructor(private API: ApiService, private _activated_route: ActivatedRoute,
    private util : UtilService
  ) {

     this.fields = [
      {label : "Network Name" , key : 'businessNetworkName' ,
        disabled : false ,
        required : true,
        validate : true ,
        min : 5,
        max : 30,
        minText : 'Minimum 5 chars is required',
        requiredText : 'Network name is required',
        maxText : 'Maximum 30 chars is allowed',
      },
      {label : "Owner" , key : "owner" , disabled : true},
      {label : "Members" , key : "members" , disabled : true},
     ];

     this.columns = [
      {label : 'Members' , key : 'fullName'},
      {label : 'Email' , key : 'email'},
      {label : 'Title' , key : 'title'},
      {label : 'Organization' , key : 'organisation'},
     ];

     this.businessNetworkDetails = {
       networkName : "Prasnana",
       owner : "pp@gmail.com",
       members : 10
     }



     this._activated_route.queryParams.subscribe(res => {
      this.businessNetworkId = res.networkId;
     });


   }

  ngOnInit(): void {
    if (this.businessNetworkId) {
      this.getBusinessUserNetworkMembers();
    }
  }


  getBusinessUserNetworkMembers() {
    this.util.startLoader();
    this.API.create('business/findBusinessUsersNetworkMemebers', { businessNetworkId: this.businessNetworkId, ...this.payload }).subscribe(response => {
      this.util.stopLoader();
      if (response.code === AppSettings.SUCESS_CODE) {
        const users = response.data.userDetails;
        const searchKey = response.data.searchAfterKey;

        if (users) {
          const current = users;
          const exist = this.userDatas.getValue();
          this.userDatas.next([...exist , ...current]);
        }

        if(users != null && (users.length === 0 ||
          JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))){
          this.stopScroll = true;
        }

        this.prevSearchAfterKey =  searchKey;
        const { userData , ...rest } = response.data.network;
        let data = {
          ...rest,
          owner : userData.firstName + " " + userData.lastName,
          members: rest.membersCount,
          userId : userData.userId
        }
        this.businessNetworkDetails = data;
      }
    });
  }

  updateBusinessNetwork(event) {
    this.API.updatePut('business/updateBusinessUsersNetwork', event).subscribe(res => {
      if (res && res.code === '00000') {
        Swal.fire({
          icon : "success",
          title : 'Member Network Updated!',
          text : 'Member Network updated successfully',
          showConfirmButton: false,
          allowOutsideClick : false,
          timer: 1000,
        });
        this.businessNetworkDetails = event;
      }else if(res.code=="99998"){
        Swal.fire({
          icon: 'info',
          title: 'Network already exists',
        });
      }
      this.util.stopLoader();
    });
  }


  updateBusinessNetworkMembers(members: any) {
    const userData = members.value;
    let data = {
      businessNetworkId: this.businessNetworkId,
      userId: userData.userId,
      status: userData.connectionStatus
    }
    if(members.checked){
       this.util.startLoader();
       this.updateMembersbulk(data);
    }
    else{
      SWAL_WITH_BUTTONS.fire({
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        allowOutsideClick : false,
        title : "Inactive Member From Network",
        text : `Are you sure you want to inactive ${userData.fullName}?`
      }).then(res=>{

         const  updatedData =  JSON.parse(JSON.stringify(this.userDatas.getValue()));

        if(res.isConfirmed){
          this.updateMembersbulk(data);
        }
        else{
          updatedData.forEach(res=>{
            if(res.userId === userData.userId){
              res.connectionStatus = "ACTIVE";
            }
          });
          this.userDatas.next(updatedData);
        }



      });


    }

  }


  updateMembersbulk(data){
    this.API.create('business/updateBusinessUsersNetworkMemebers', [data]).subscribe(res => {
      if (res && res.code === '00000') {
        Swal.fire({
          icon : "success",
          title : 'Member Updated!',
          text : 'Member updated successfully',
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          this.payload.searchAfterKey = null;
          this.prevSearchAfterKey = null;
          this.stopScroll = false;
          this.userDatas.next([]);
          this.getBusinessUserNetworkMembers();
        }, 1000);
        this.util.stopLoader();
      }
    });
  }


  onSearch(value , obj : NetworkDetailsComponent){
    obj.payload = {
      ...obj.payload,
      searchContent : value,
      searchAfterKey : null
    };
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getBusinessUserNetworkMembers();
  }

  onFilter(data , obj : NetworkDetailsComponent){
    console.log("FILTERED DATA" , data);
    obj.payload = {
      ...obj.payload,
      status : data.status,
      searchAfterKey : null
    }
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getBusinessUserNetworkMembers();
  }

  onScroll(obj : NetworkDetailsComponent){
    if(!this.stopScroll){
      obj.payload = {
        ...obj.payload,
        searchAfterKey : obj.prevSearchAfterKey
      };
      obj.getBusinessUserNetworkMembers();
    }
  }


}
